module.exports = __webpack_public_path__ + "static/media/st.6a9fb92e.jpg";